/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_CampaignsInputs */

const cs_reports_campaigns = /** @type {(inputs: Reports_CampaignsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výkon kampaní`)
};

const en_reports_campaigns = /** @type {(inputs: Reports_CampaignsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaign performance`)
};

/**
* | output |
* | --- |
* | "Campaign performance" |
*
* @param {Reports_CampaignsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_campaigns = /** @type {((inputs?: Reports_CampaignsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_CampaignsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_campaigns(inputs)
	return cs_reports_campaigns(inputs)
});